import controller from './payment-method.controller';

export default {
  bindings: {
    invoice: '<',
    packet: '<',
    msisdn: '<',
    bill: '@',
    formReference: '<',
    promocode: '<',
    offerable: '<'
  },
  controller,
  template: require('./payment-method.html')
};



// WEBPACK FOOTER //
// src/app/no-auth/components/payment-method/payment-method.component.ts